<template>
  <div>
    <template v-if="$wait.is('selecting duplicate product')">
      <v-row
        class="relative text-center fill-height align-center"
        wrap
      >
        <v-col cols="12">
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          />
        </v-col>
      </v-row>
    </template>

    <v-data-table
      v-else
      :headers="headers"
      :items="items"
      :loading="$wait.is('fetching items')"
      disable-sort
      hide-default-footer
    >
      <template v-slot:item="props">
        <tr
          style="cursor: pointer"
          @click="itemSelected(props.item)"
        >
          <td class="text-h6 pa-5">
            <template v-if="$store.getters.locale === $store.state.secondaryLocale">{{ props.item.nameTranslated }}</template>
            <template v-else>{{ props.item.name }}</template>
          </td>
          <td class="text-h6 pa-5">{{ _.get(props, 'item.brand.name', '-') }}</td>
          <td class="text-h6 pa-5">
            <template v-if="itemIsProduct(props.item)">{{ props.item.retailPromo ? props.item.retailPromo : props.item.retailPrice | money }}</template>
            <template v-else>-</template>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import productTypeMixin from '@/utils/mixins/productTypeMixin'
import productService from '@/services/products'
import camelcaseKeys from 'camelcase-keys'

export default {
  name: 'ProductChooser',
  mixins: [ productTypeMixin ],
  props: {
    barcode: {
      type: String,
      default: null,
      required: true
    }
  },
  data () {
    return {
      headers: [
        {
          text: this.$t('Name'),
          value: 'name',
          width: '60%'
        },
        {
          text: this.$t('Brand'),
          value: 'brand.name'
        },
        {
          text: this.$t('Price'),
          value: 'retailPrice'
        }
      ],
      items: []
    }
  },
  created () {
    this.$wait.start('fetching items')
    return productService.findAllByBarcode(this.barcode)
      .then(data => {
        this.items = camelcaseKeys(data.data.products, { deep: true })
      })
      .catch(data => { if (data && data.message) this.helpers.toastError(data.message) })
      .finally(() => this.$wait.end('fetching items'))
  },
  methods: {
    itemSelected (item) {
      this.$emit('item-selected', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/products/ProductChooser.vue